module.exports = __webpack_public_path__ + "img/6_25.331e9c04.png";